import { z } from 'zod';

/** Busca global (⌘K): GET /busca?q=. Cada grupo so existe para quem tem a permissao da tela correspondente. */
export const buscaSchema = z.object({ q: z.string().trim().min(1, 'Digite algo para buscar').max(100) });
export type BuscaQuery = z.infer<typeof buscaSchema>;

export interface BuscaItem {
  id: string;
  codigo: string;
  descricao: string;
  tipo: string;
}
export interface BuscaOrcamento {
  id: string;
  /** "900012-v1" (numero e versao de referencia). */
  numeroExibido: string;
  clienteNome: string | null;
  status: string;
}
export interface BuscaCliente {
  id: string;
  nome: string;
  documento: string | null;
}
export interface BuscaFornecedor {
  id: string;
  nome: string;
  documento: string | null;
}
export interface BuscaResponse {
  itens?: BuscaItem[];
  orcamentos?: BuscaOrcamento[];
  clientes?: BuscaCliente[];
  fornecedores?: BuscaFornecedor[];
}
